import React from 'react';

import InhouseMun2024 from 'views/InhouseMun2024';

const SchoolProgrampage = () => {
  return <InhouseMun2024 />;
};

export default SchoolProgrampage;